<template>
  <div class="main">
    <!-- -->
    <div class="content">
      <div class="info" v-for="item in infoList" :key="item.key">
        <div style="width: 110px;">{{ item.label }}</div>
        <div>{{ item.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/api/index'
import { formatDateTime } from '@/utils/time'
export default {
  name: "OpenWebBaseInfo",

  data() {
    return {
      info: {
        projectName: "-",
        phone: "-",
        createdAt: "-",
        lastLogin: "-",
      },
    };
  },
  computed: {
    // infoList 转 computed：label 随语言热切换
    infoList() {
      return [
        { label: this.$t("base.project_name"), value: this.info.projectName, key: 1 },
        { label: this.$t("base.phone"), value: this.info.phone, key: 2 },
        { label: this.$t("base.register_time"), value: this.info.createdAt, key: 3 },
        { label: this.$t("base.last_login_time"), value: this.info.lastLogin, key: 4 },
      ];
    },
  },

  mounted() {
    this.getInfo()
  },

  methods: {
    getInfo(){
      getUserInfo().then(res=>{
        const data = res.data
        let name = ""
        data.projectName?.map(f=>{
          name += f.name + "、"
        })
        this.info.projectName = name.slice(0, -1);
        this.info.phone = data.phoneNum
        this.info.createdAt = formatDateTime(data.createdAt, this.$i18n.locale)
        this.info.lastLogin = formatDateTime(data.lastLoginTime, this.$i18n.locale)
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  height: 100%;
  padding: 0 10px;
  // width: 100%;
  background-color: #ecf0f3;
  .content {
    height: calc(100% - 20px);
    background-color: #fff;
    padding: 10px;
    .info {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      // width: 300px;
      margin-bottom: 20px;
      font-size: 15px;
    }

    // align-items: center;
    // justify-content: center;
  }
}
</style>